import { render, staticRenderFns } from "./ride-card.vue?vue&type=template&id=f5c6fc6e"
import script from "./ride-card.vue?vue&type=script&lang=js"
export * from "./ride-card.vue?vue&type=script&lang=js"
import style0 from "./ride-card.vue?vue&type=style&index=0&id=f5c6fc6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports